var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87231 11.7448C5.51343 11.7448 5.20621 11.617 4.95064 11.3614C4.69508 11.1059 4.5673 10.7986 4.5673 10.4398V2.6097C4.5673 2.25082 4.69508 1.9436 4.95064 1.68803C5.20621 1.43247 5.51343 1.30469 5.87231 1.30469H11.7449C12.1037 1.30469 12.411 1.43247 12.6665 1.68803C12.9221 1.9436 13.0499 2.25082 13.0499 2.6097V10.4398C13.0499 10.7986 12.9221 11.1059 12.6665 11.3614C12.411 11.617 12.1037 11.7448 11.7449 11.7448H5.87231ZM5.87231 10.4398H11.7449V2.6097H5.87231V10.4398ZM3.26229 14.3548C2.90341 14.3548 2.59619 14.227 2.34062 13.9715C2.08506 13.7159 1.95728 13.4087 1.95728 13.0498V3.91471H3.26229V13.0498H10.4398V14.3548H3.26229Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.405ade46f2765520ca86660ef3257f08.svg";
export { ForwardRef as ReactComponent };